module.exports = __webpack_public_path__ + "static/media/PC_Workshop_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.7902ff99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desenvolvimentoArq/PC_Workshop_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png
// module id = 79
// module chunks = 0